import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Order matters: tokens first, then the primitives a component may override.
// Component stylesheets load after these, via the components that own them.
import './index.css'
import './styles/primitives.css'
import './styles/layout.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
